import React from "react";
import FirstRestaurant from "./components/restaurant/FirstRestaurant";
import SecondRestaurant from "./components/restaurant/SecondRestaurant";
import ThirdRestaurant from "./components/restaurant/ThirdRestaurant";
import FourthRestaurant from "./components/restaurant/FourRestaurant";
import FifthRestaurant from "./components/restaurant/FifthRestaurant";

const Restaurant = () => {
  return (
    <>
      <FirstRestaurant />
      <SecondRestaurant />
      <ThirdRestaurant />
      <FourthRestaurant />
      <FifthRestaurant />
    </>
  );
};

export default Restaurant;
